import { render, staticRenderFns } from "./content-sections.datagrid.vue?vue&type=template&id=5a8c1854&scoped=true&"
import script from "./content-sections.datagrid.vue?vue&type=script&lang=js&"
export * from "./content-sections.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./content-sections.datagrid.vue?vue&type=style&index=0&id=5a8c1854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c1854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
